import { useMutation, useQueryClient } from "@tanstack/react-query";
import projectUtils from "../utils/project-utils.js";
import {navigateHook} from "./use-navigate.js";
export const useEntityMutation = ({
                                    service,
                                    getInvalidateKeys,
                                    navigatePath,
                                    onCustomSuccess,
                                    onCustomError,
                                  }) => {
  const queryClient = useQueryClient();
  const navigate = navigateHook();

  return useMutation({
    mutationFn: ({ method, payload, id = null }) => {
      console.log(payload)
      switch (method) {
        case "create": return service.save(payload);
        case "update": return service.update(id, payload);
        case "delete": return service.destroy(id);
        default: throw new Error("Método de mutação inválido");
      }
    },
    onSuccess: async (data, variables) => {
      const { showSuccessAlert = true } = variables;
      if (typeof getInvalidateKeys === 'function') {
        const keysToInvalidate = getInvalidateKeys(data, variables);

        if(keysToInvalidate && Array.isArray(keysToInvalidate)){
          keysToInvalidate.forEach(queryKeyArray => {
            queryClient.invalidateQueries({ queryKey: queryKeyArray });
          });
        }
      }
      if (variables.method !== "delete") {
        if(showSuccessAlert){
          projectUtils.success(!variables.id);
        }

        if (onCustomSuccess) {
          onCustomSuccess(data, variables);
        }

        if (!variables.id) {
          if (navigatePath) {
            navigate(`/${navigatePath}/form/${data.id}`, false);
          }
        }
      } else {
        projectUtils.success(true, "Excluído com sucesso");
        if (navigatePath) {
          navigate(`/${navigatePath}`, false);
        }
      }
    },
    onError: (err, { method }) => {
      let message = err.response?.data?.message;

      if(onCustomError) {
        onCustomError();
        return;
      }
      console.error(err);
      if (!message) {
        message = method === "delete" ? "Não foi possível excluir." : "Erro desconhecido";
      }
      projectUtils.swalErrorMessage("", message, "Ok");
    }
  });
};